import React from "react";
import numeral from "numeral";
const CounterDetails = ({ metric: { metric } }) => /* @__PURE__ */ React.createElement("dl", { className: "metric-def metric-counter" }, /* @__PURE__ */ React.createElement("dt", null, "Value:"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("span", { className: "number-format" }, numeral(metric.count).format("0,0"))));
export default CounterDetails;
